import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './styles/tokens.css';
import './styles/typography.css';
import './styles/global.css';
import App, { preloadRoute } from './App';

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

if (!rootElement) {
  throw new Error('Unable to mount the application: #root was not found.');
}

// react-snap does not serialize the route chunk it loaded while crawling.
// Resolve it before either mount path so the first render is deterministic.
preloadRoute(window.location.pathname)
  .then(() => {
    if (!rootElement.hasChildNodes()) {
      ReactDOM.createRoot(rootElement).render(app);
    } else {
      ReactDOM.hydrateRoot(rootElement, app);
    }
  })
  .catch((error) => {
    // Keep a pregenerated page readable if its JavaScript chunk is temporarily
    // unavailable. An empty development mount still gets a useful error state.
    console.error('Unable to initialise the interactive site.', error);
    if (!rootElement.hasChildNodes()) {
      rootElement.textContent = 'The page could not load. Please refresh and try again.';
    }
  });
